<nb-card>
  <nb-card-header>
    <h6>{{ purchaseDetail.productName }}</h6>
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <table class="table table-sm table-borderless tbl-purchase-summary">
      <tr>
        <td class="col-label">{{ "common.quantity" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <nb-form-field fullWidth>
              <button
                nbPrefix
                nbButton
                ghost
                (click)="productQuantityIncrement(-1)"
              >
                <nb-icon icon="minus-circle-outline"> </nb-icon>
              </button>
              <input
                type="number"
                nbInput
                fullWidth
                shape="semi-round"
                class="form-control"
                placeholder="Nhập số lượng"
                [status]="purchaseDetail.quantity > 0 ? 'primary' : 'danger'"
                [(ngModel)]="purchaseDetail.quantity"
                (change)="summaryPurchaseDetail()"
              />
              <button
                nbSuffix
                nbButton
                ghost
                (click)="productQuantityIncrement(1)"
              >
                <nb-icon icon="plus-circle-outline"> </nb-icon>
              </button>
            </nb-form-field>
          </div>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "common.unitPrice" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              [status]="purchaseDetail.price > 0 ? 'primary' : 'danger'"
              [(ngModel)]="purchaseDetail.price"
              (change)="summaryPurchaseDetail()"
              (keydown.enter)="summaryPurchaseDetail()"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "common.totalAmount" | translate }}:</td>
        <td class="col-number">
          <h6 class="text-primary">{{ purchaseDetail.netAmount | number }}</h6>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "common.discount" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <input
              *ngIf="!inputDiscountAmount"
              type="number"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              style="width: 20px"
              min="0"
              max="100"
              placeholder="% ck"
              [(ngModel)]="purchaseDetail.discountPercent"
              (change)="summaryPurchaseDetail()"
            />

            <button
              *ngIf="!inputDiscountAmount"
              nbButton
              fullWidth
              outline
              shape="semi-round"
              status="basic"
              size="small"
              (click)="openInputDiscountAmount()"
            >
              <span> {{ purchaseDetail.discountAmount | number }} </span>
            </button>

            <nb-form-field *ngIf="inputDiscountAmount" fullWidth>
              <button
                nbPrefix
                nbButton
                ghost
                (click)="closeInputDiscountAmount()"
              >
                <nb-icon icon="close-outline"> </nb-icon>
              </button>
              <input
                type="number"
                nbInput
                fullWidth
                shape="semi-round"
                class="form-control"
                placeholder="$ ck"
                [status]="
                  purchaseDetail.discountAmount > 0 ? 'primary' : 'danger'
                "
                [(ngModel)]="purchaseDetail.discountAmount"
                (change)="summaryPurchaseDetail()"
                (keydown.enter)="closeInputDiscountAmount()"
              />
            </nb-form-field>
          </div>
        </td>
      </tr>
      <tr>
        <td class="col-label">
          <h6 class="text-hint">Tổng cộng:</h6>
        </td>
        <td class="col-number">
          <h6 class="text-danger">
            {{ purchaseDetail.amount | number }}
          </h6>
        </td>
      </tr>

      <tr>
        <td colspan="2" class="col-label">
          <textarea
            nbInput
            fullWidth
            rows="2"
            placeholder="Nhập ghi chú"
            class="form-control"
            [(ngModel)]="purchaseDetail.comment"
          ></textarea>
        </td>
      </tr>
    </table>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      status="primary"
      size="small"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
